import React, { memo, useEffect } from 'react'
import {
  GoogleMap,
  LoadScript,
  Marker,
  GoogleMapProps,
  useGoogleMap,
} from '@react-google-maps/api'
import mapStyles from './OutdoorMap.styles.json'
import {
  OutdoorMapOffsetPropTypes,
  OutdoorMapPropTypes,
} from './OutdoorMap.types'
import MarkerIcon from '../../assets/images/google-map-marker.webp'
import NearbyPlaces from './components/NearbyPlaces/NearbyPlaces'
import LandmarkPins from './components/NearbyPlaces/LandmarkPins'
import './OutdoorMap.scss'

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    google: any
  }
}
const OutdoorMapOffset = ({
  offset,
  center,
}: OutdoorMapOffsetPropTypes): JSX.Element => {
  const map = useGoogleMap()

  useEffect(() => {
    map.panBy(offset, 0)
  }, [map, offset, center])

  return <></>
}

const MapOffset = memo(OutdoorMapOffset)

const OutdoorMap = ({
  id,
  className,
  radius,
  offset = 0,
  markerLocations,
  center,
  zoom,
  nearbyPlacesTypes,
  propertyName,
}: GoogleMapProps & OutdoorMapPropTypes): JSX.Element => {
  return (
    <LoadScript
      googleMapsApiKey={process.env.GATSBY_MAP_API_KEY}
      libraries={['places']}
    >
      <GoogleMap
        id={id}
        mapContainerClassName={className}
        zoom={zoom}
        center={center}
        options={{
          // styles: mapStyles,
          zoomControlOptions: {
            position: 6,
          },
          fullscreenControlOptions: {
            position: 5,
          },
          mapTypeControl: false,
          streetViewControl: false,
        }}
      >
        {!!center && <MapOffset offset={offset} center={center} />}
        {typeof radius !== 'undefined' && (
          <Marker
            key={`${center.lat}<>${center.lng}`}
            position={center}
            zIndex={100}
            icon={MarkerIcon}
            label={{
              color: '#fff',
              text: propertyName,
              className: 'markerLabel',
            }}
          />
        )}
        {!!markerLocations &&
          markerLocations.map((markerLocation) => {
            return (
              <LandmarkPins
                key={markerLocation.position.lat}
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...markerLocation}
              />
            )
          })}
        {!!center && !!nearbyPlacesTypes && !!radius && (
          <NearbyPlaces
            center={center}
            radius={radius}
            nearbyPlacesTypes={nearbyPlacesTypes}
          />
        )}
      </GoogleMap>
    </LoadScript>
  )
}

export default memo(OutdoorMap)
